module.exports = __webpack_public_path__ + "img/logo_wow_1_fondblanc.79dd12a8.png";